import PropTypes from 'prop-types'
import cn from '../modules/cn'
import propTypeDeprecation from '../modules/propTypeDeprecation'

function Skeleton({
  className,
  xs,
  sm,
  lg,
  xl,
  icon,
  fontSize,
}) {
  const style = [
    'rounded bg-gray-500 animate-pulse h-4 w-full mt-0.5',
    icon && 'w-4 rounded-full mt-0',
    xs && 'h-2',
    sm && 'h-3',
    lg && 'h-5',
    xl && 'h-6',
    icon && 'w-[1em] h-[1em]',
    fontSize && `text-[${fontSize}]`,
    className,
  ]

  return <div className={cn(style)} />
}

Skeleton.propTypes = {
  className: cn.propType,
  icon: PropTypes.bool,
  xs: PropTypes.bool,
  sm: PropTypes.bool,
  lg: PropTypes.bool,
  xl: PropTypes.bool,
  fontSize: propTypeDeprecation(PropTypes.string),
}

Skeleton.defaultProps = {
  className: null,
  icon: false,
  xs: false,
  sm: false,
  lg: false,
  xl: false,
  fontSize: null,
}

export default Skeleton
